module.exports = __webpack_public_path__ + "static/media/star.e9d942d4.svg";